var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"time-left"},[_vm._t("before"),_vm._v(" "+_vm._s(_vm.time)+" "),_vm._t("after")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }